import { AppIcon, type IconName } from '@/components/ui'
import { useTranslation } from 'react-i18next'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router'
import './shell.css'

/**
 * Bottom navigation: three labelled tabs; the open one is inverted (black
 * block, white icon and label). Tapping it again scrolls back to the top.
 */
const TABS: { to: string; icon: IconName; labelKey: string }[] = [
  { to: '/', icon: 'meetings', labelKey: 'nav.meetings' },
  { to: '/summary', icon: 'summary', labelKey: 'nav.summary' },
  { to: '/me', icon: 'account', labelKey: 'nav.me' },
]

export function Shell() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  return (
    <>
      <Outlet />
      <nav className="shell-nav" aria-label={t('navLabel')}>
        <div className="shell-nav__inner">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === '/'}
              className="shell-tab pressable"
              onClick={(e) => {
                if (location.pathname === tab.to) {
                  e.preventDefault()
                  document.getElementById('root')?.scrollTo({ top: 0 })
                  if (location.search) navigate(tab.to, { replace: true })
                }
              }}
            >
              {({ isActive }) => (
                <>
                  <AppIcon name={tab.icon} size={24} strokeWidth={isActive ? 2 : 1.5} />
                  <span className="t-label-sm">{t(tab.labelKey)}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  )
}
